import type {
  ColumnsSection,
  RowSection,
  TableContent,
  ValuesSection,
} from "./contentItemSchemas";
import {
  columnsSectionSchema,
  parseWithRecord,
  parseTableContentFromFields,
  rowSectionSchema,
  tableContentFieldsSchema,
  valuesSectionSchema,
} from "./schemas";

export const parseColumnsSection = (item: unknown): ColumnsSection =>
  parseWithRecord(item, columnsSectionSchema);

export const parseValuesSection = (item: unknown): ValuesSection =>
  parseWithRecord(item, valuesSectionSchema);

export const parseRowSection = (item: unknown): RowSection =>
  parseWithRecord(item, rowSectionSchema);

export const parseTableContent = (
  item: unknown,
  formLabel?: string,
): TableContent => {
  const parsed = parseWithRecord(item, tableContentFieldsSchema);
  return parseTableContentFromFields(parsed, formLabel);
};
